
import Vue from "vue"
import Toast from "./components/Toast.vue";
import { ToastOptions } from "./components/ToastOptions";

export * from "./components/ToastOptions";

export default function (message: string, options?: ToastOptions) {

    let v: Vue | null = null;
    const close = () => {
        if (v) {
            v.$destroy();
        }
    };

    v = new Vue({
        render: (h) => h(Toast, {
            props: {
                msg: message,
                options
            },
            on: {
                close
            }
        }),
    });

    const div = document.createElement("div");
    document.body.appendChild(div);

    v.$mount(div);

}
